import { upperCaseFirst } from '@neo-one/utils';
export const getSetterName = (name) => `set${upperCaseFirst(name)}`;

//# sourceMappingURL=getSetterName.js.map
